<template>
<div class="chapter">
<div class="inner_page">
<div class="centerfull" epub:type="cover">
<img alt="Helper Hounds. Spooky Helps Danny Tell the Truth. By Caryn Rivadeneira." src="image/cover.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?b1773268